import { render, staticRenderFns } from "./ExerciseEntityDetails.vue?vue&type=template&id=359c6332&scoped=true"
import script from "./ExerciseEntityDetails.vue?vue&type=script&lang=js"
export * from "./ExerciseEntityDetails.vue?vue&type=script&lang=js"
import style0 from "./ExerciseEntityDetails.vue?vue&type=style&index=0&id=359c6332&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359c6332",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('359c6332')) {
      api.createRecord('359c6332', component.options)
    } else {
      api.reload('359c6332', component.options)
    }
    module.hot.accept("./ExerciseEntityDetails.vue?vue&type=template&id=359c6332&scoped=true", function () {
      api.rerender('359c6332', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ExerciseEntityDetails.vue"
export default component.exports